import './cvapi-usage-bar.scss';
import templateUrl from './cvapi-usage-bar.html';

export default /* @ngInject */ function cvapiUsage() {
    return {
        templateUrl: templateUrl,
        scope: {},
        link: (scope, element, attrs) => {

            scope.percentage = 0;

            function calculatePercentage() {
                scope.percentage = ( scope.usage * 100.0 ) / scope.limit;
            }

            attrs.$observe('limit', (newValue) => {
                scope.limit = newValue;
                calculatePercentage();
            });

            attrs.$observe('usage', (newValue) => {
                scope.usage = newValue;
                if(scope.usage < 0){
                    scope.percentage = 0;
                    scope.usageError = true;
                    return;
                }
                calculatePercentage();
            });

        }
    };
}



// WEBPACK FOOTER //
// ./user/directives/cvapi-usage-bar.js